/**
 * `sqlEngineToDatabaseEngineId` — maps the grammar-layer `SqlEngine`
 * (which uses `'postgres'`) to the connection-store's `DatabaseEngineId`
 * (which uses `'pgsql'`). Only `postgres`/`pgsql` differs between the two
 * unions; every other id is identical.
 *
 * Shared single source of truth so callers in different feature slices
 * (VQE-Edit live schema pull, Table Designer JSON toggle, …) converge on
 * one exhaustive, `SqlEngine`-typed mapping instead of duplicating weaker
 * string-cast variants. Type-only import of `SqlEngine` keeps this leaf
 * util free of runtime/transitive deps.
 */
import type { SqlEngine } from '../../features/sql-grammar/model';
import type { DatabaseEngineId } from './engineTypes';

const DATABASE_ENGINE_ID_BY_ENGINE: Readonly<
  Record<SqlEngine, DatabaseEngineId>
> = {
  mssql: 'mssql',
  postgres: 'pgsql',
  mysql: 'mysql',
  oracle: 'oracle',
  sqlite: 'sqlite',
};

export function sqlEngineToDatabaseEngineId(
  engine: SqlEngine,
): DatabaseEngineId {
  return DATABASE_ENGINE_ID_BY_ENGINE[engine];
}
